const AuthErrorTypes = {
  wrongEmailOrPassword: 'auth.wrong_email_or_pass',
  phoneNumberNotExists: 'auth.phone_not_exist',
  errorPhoneTaken: 'auth.phone_taken',
  emailAlreadyTaken: 'auth.email_taken',
  invalidAccessCode: 'auth.invalid_access_code',
};

export default AuthErrorTypes;
